import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { Workspace } from '../types'

type WorkspaceSelector = (state: ReduxState) => Workspace
const getWorkspace: WorkspaceSelector = state => state.workspaces.activeWorkspace

export const workspaceSelector: WorkspaceSelector = createSelector(getWorkspace, workspace => workspace)
